export const createMessageBoxSlice = (set) => ({
  title: '',
  setTitle: (title) => {
    set((state) => {
      state.messageBox.title = title;
    });
  },
  description: '',
  setDescription: (description) => {
    set((state) => {
      state.messageBox.description = description;
    });
  },
  type: 'alert',
  setType: (type) => {
    set((state) => {
      state.messageBox.type = type;
    });
  },
  revealed: false,
  setRevealed(revealed) {
    set((state) => {
      state.messageBox.revealed = revealed;
    });
  },
  setResponseHandler(responseHandler) {
    set((state) => {
      state.messageBox.responseHandler = responseHandler;
    });
  },
  time: 0,
  setTime: (time) => {
    set((state) => {
      state.messageBox.time = time;
    });
  },
  setMessageBoxAttributes({ revealed, title, description, type, time }) {
    set((state) => {
      state.messageBox.revealed = revealed;
      state.messageBox.title = title;
      // state.messageBox.description = description;
      state.messageBox.description = <div dangerouslySetInnerHTML={{ __html: description }} />;
      state.messageBox.type = type;
      state.messageBox.time = time;
    });
  },
});
